/**
 * Canal de eventos del negocio en Firebase Realtime Database.
 *
 * Es el mismo nodo (nombre del negocio sin espacios) que usan la app móvil
 * (pushFirebase en globals.js) y la transferencia de chasis
 * (dialogTransferir): cada evento es { Accion, Descripcion, Modulo, Fecha,
 * Hora, Sucursal, Usuario }, con Descripcion como texto JSON.
 */
import { initializeApp, getApps, getApp } from "firebase/app";
import { getDatabase, ref, push, onChildAdded, query, limitToLast } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDTz01ErbwTUg7Kjz0ayhMKr8NXgzOOQJs",
  authDomain: "webmotors-e1b4a.firebaseapp.com",
  databaseURL: "https://webmotors-e1b4a-default-rtdb.firebaseio.com",
  projectId: "webmotors-e1b4a",
  storageBucket: "webmotors-e1b4a.appspot.com",
  messagingSenderId: "21788133575",
  appId: "1:21788133575:web:11592e57db8c3bd81396e2",
  measurementId: "G-5J6JYV3TJS",
};

const baseDeDatos = () => getDatabase(getApps().length ? getApp() : initializeApp(firebaseConfig));

/**
 * Nodo del negocio: el nombre sin espacios y sin los caracteres que Firebase
 * prohíbe en una ruta (. # $ [ ]); con ellos ref() lanza y la pantalla se
 * cae (p. ej. "Moto Prestamos J. Villavicencio Mi Abuelita"). Debe coincidir
 * con nodoNegocio() de la app móvil (globals.js).
 */
export const nodoNegocio = () => {
  let negocio = "";
  try {
    negocio = localStorage.getItem("nombrenegocio") || "";
  } catch (e) {
    negocio = "";
  }
  return negocio.replace(/[ .#$[\]]/g, "");
};

/** Publica un evento; nunca lanza (el aviso en vivo es complementario). */
export function publicarEventoNegocio({ accion, descripcion, modulo, sucursal, usuario }) {
  const nodo = nodoNegocio();
  if (!nodo) return Promise.resolve();
  const d = new Date();
  return push(ref(baseDeDatos(), nodo), {
    Accion: accion,
    Descripcion: typeof descripcion === "string" ? descripcion : JSON.stringify(descripcion),
    Modulo: modulo,
    Fecha: `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}`,
    Hora: Date.now().toString(),
    Sucursal: sucursal || "",
    Usuario: usuario || "",
  }).catch(() => {});
}

/**
 * Llama a `alRecibir(evento)` por cada evento nuevo del negocio. El último
 * evento previo llega al suscribirse y se ignora salvo que sea de los últimos
 * minutos (la hora la pone el equipo que publica y puede venir desfasada; un
 * aviso de más solo provoca un refresco). Devuelve la función para
 * desuscribirse.
 */
export function escucharEventosNegocio(alRecibir) {
  const nodo = nodoNegocio();
  if (!nodo) return () => {};
  const desde = Date.now() - 5 * 60 * 1000;
  try {
    return onChildAdded(query(ref(baseDeDatos(), nodo), limitToLast(1)), (snap) => {
      const ev = snap.val() || {};
      if (Number(ev.Hora) >= desde) alRecibir(ev);
    });
  } catch (e) {
    return () => {};
  }
}
